export const PATIENT_CURRENT_APPOINTMENT_OPTIONS = {
  CURRENT_APPOINTMENT_DATE: "Patient.CurrentAppointment.Date",
  CURRENT_APPOINTMENT_DATE_TIME: "Patient.CurrentAppointment.DateTime",
  CURRENT_APPOINTMENT_STAFF_NAME: "Patient.CurrentAppointment.StaffName",
  CURRENT_APPOINTMENT_TYPE: "Patient.CurrentAppointment.Type",
  CURRENT_APPOINTMENT_CLINIC: "Patient.CurrentAppointment.Clinic",
  CURRENT_APPOINTMENT_STATUS: "Patient.CurrentAppointment.Status",
  CURRENT_APPOINTMENT_OUTCOME_NOTES: "Patient.CurrentAppointment.OutcomeNotes",
  CURRENT_APPOINTMENT_ROOM: "Patient.CurrentAppointment.Room",
  CURRENT_APPOINTMENT_PHYSICIAN_REFERRAL:
    "Patient.CurrentAppointment.PhysicianReferral",
  CURRENT_APPOINTMENT_COMPANION_TYPE:
    "Patient.CurrentAppointment.CompanionType",
  CURRENT_APPOINTMENT_COMPANION_NAME:
    "Patient.CurrentAppointment.CompanionName",
  CURRENT_APPOINTMENT_NOTES: "Patient.CurrentAppointment.Notes",
  CURRENT_APPOINTMENT_CHART_NOTES: "Patient.CurrentAppointment.ChartNotes",
  CURRENT_APPOINTMENT_STAFF_SIGNATURE:
    "Patient.CurrentAppointment.StaffSignature",
  // SN-19877 (Anvil parity)
  CURRENT_APPOINTMENT_TIME: "Patient.CurrentAppointment.Time",
  CURRENT_APPOINTMENT_PROVIDER_LICENSE_NUMBER:
    "Patient.CurrentAppointment.Provider.LicenseNumber",
  CURRENT_APPOINTMENT_REFERRAL_SOURCE:
    "Patient.CurrentAppointment.ReferralSource",
  CURRENT_APPOINTMENT_DIRECT_SUPERVISING_PROVIDER_FULL_NAME:
    "Patient.CurrentAppointment.DirectSupervisingProvider.FullName",
  CURRENT_APPOINTMENT_DIRECT_SUPERVISING_PROVIDER_SIGNATURE:
    "Patient.CurrentAppointment.DirectSupervisingProvider.Signature",
  CURRENT_APPOINTMENT_SUPERVISING_PROVIDER_FULL_NAME:
    "Patient.CurrentAppointment.SupervisingProvider.FullName",
  CURRENT_APPOINTMENT_SUPERVISING_PROVIDER_SIGNATURE:
    "Patient.CurrentAppointment.SupervisingProvider.Signature"
};

export const PATIENT_APPOINTMENTS_OPTIONS = {
  NEXT_APPOINTMENT_DATE: "Patient.NextAppointment.Date",
  NEXT_APPOINTMENT_DATE_TIME: "Patient.NextAppointment.DateTime",
  NEXT_APPOINTMENT_STAFF_NAME: "Patient.NextAppointment.StaffName",
  NEXT_APPOINTMENT_TYPE: "Patient.NextAppointment.Type",
  NEXT_APPOINTMENT_CLINIC: "Patient.NextAppointment.Clinic",
  NEXT_APPOINTMENT_STATUS: "Patient.NextAppointment.Status",
  NEXT_APPOINTMENT_OUTCOME_NOTES: "Patient.NextAppointment.OutcomeNotes",
  NEXT_APPOINTMENT_ROOM: "Patient.NextAppointment.Room",
  NEXT_APPOINTMENT_PHYSICIAN_REFERRAL:
    "Patient.NextAppointment.PhysicianReferral",
  NEXT_APPOINTMENT_COMPANION_TYPE: "Patient.NextAppointment.CompanionType",
  NEXT_APPOINTMENT_COMPANION_NAME: "Patient.NextAppointment.CompanionName",
  NEXT_APPOINTMENT_NOTES: "Patient.NextAppointment.Notes",
  NEXT_APPOINTMENT_CHART_NOTES: "Patient.NextAppointment.ChartNotes",
  NEXT_APPOINTMENT_STAFF_SIGNATURE: "Patient.NextAppointment.StaffSignature",
  NEXT_APPOINTMENT_STAFF_EMAIL: "Patient.NextAppointment.StaffEmail",
  NEXT_APPOINTMENT_TELEHEALTH_LINK: "Patient.NextAppointment.TelehealthLink",

  LAST_APPOINTMENT_DATE: "Patient.LastAppointment.Date",
  LAST_APPOINTMENT_DATE_TIME: "Patient.LastAppointment.DateTime",
  LAST_APPOINTMENT_STAFF_NAME: "Patient.LastAppointment.StaffName",
  LAST_APPOINTMENT_TYPE: "Patient.LastAppointment.Type",
  LAST_APPOINTMENT_CLINIC: "Patient.LastAppointment.Clinic",
  LAST_APPOINTMENT_STATUS: "Patient.LastAppointment.Status",
  LAST_APPOINTMENT_OUTCOME_NOTES: "Patient.LastAppointment.OutcomeNotes",
  LAST_APPOINTMENT_ROOM: "Patient.LastAppointment.Room",
  LAST_APPOINTMENT_PHYSICIAN_REFERRAL:
    "Patient.LastAppointment.PhysicianReferral",
  LAST_APPOINTMENT_COMPANION_TYPE: "Patient.LastAppointment.CompanionType",
  LAST_APPOINTMENT_COMPANION_NAME: "Patient.LastAppointment.CompanionName",
  LAST_APPOINTMENT_NOTES: "Patient.LastAppointment.Notes",
  LAST_APPOINTMENT_CHART_NOTES: "Patient.LastAppointment.ChartNotes",
  LAST_APPOINTMENT_STAFF_SIGNATURE: "Patient.LastAppointment.StaffSignature",

  MY_LAST_CHART_NOTE: "Patient.MyLastChartNote",

  LAST_APPOINTMENT_SALE_STATUS: "Patient.LastAppointment.Invoice.Status",
  LAST_APPOINTMENT_SALE_TOTAL: "Patient.LastAppointment.Invoice.Total",
  LAST_APPOINTMENT_SALE_PATIENT_RESPONSIBILITY:
    "Patient.LastAppointment.Invoice.PatientResponsibility",
  LAST_APPOINTMENT_SALE_PATIENT_RESPONSIBILITY_PAID:
    "Patient.LastAppointment.Invoice.PatientResponsibilityPaid",
  LAST_APPOINTMENT_SALE_PATIENT_LINE_ITEMS_COUNT:
    "Patient.LastAppointment.Invoice.LineItemsCount",
  LAST_APPOINTMENT_SALE_PATIENT_LINE_ITEMS:
    "Patient.LastAppointment.Invoice.LineItems",
  LAST_APPOINTMENT_SALE_PATIENT_PAYMENTS_TOTAL:
    "Patient.LastAppointment.Invoice.PaymentsTotal",
  LAST_APPOINTMENT_SALE_PATIENT_PAYMENTS:
    "Patient.LastAppointment.Invoice.Payments",
  LAST_APPOINTMENT_SALE_PATIENT_ADJUSTMENTS_TOTAL:
    "Patient.LastAppointment.Invoice.AdjustmentsTotal",
  LAST_APPOINTMENT_SALE_PATIENT_ADJUSTMENTS:
    "Patient.LastAppointment.Invoice.Adjustments",
  LAST_APPOINTMENT_SALE_PATIENT_REFUNDS_TOTAL:
    "Patient.LastAppointment.Invoice.RefundsTotal",
  LAST_APPOINTMENT_SALE_PATIENT_REFUNDS:
    "Patient.LastAppointment.Invoice.Refunds"
};

export const PATIENT_CURRENT_APPOINTMENT_MENU_OPTIONS = {
  title: "Current Appointment",
  menu: [
    {
      title: "Patient - Current Appointment - Date",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_DATE
    },
    {
      title: "Patient - Current Appointment - Date Time",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_DATE_TIME
    },
    {
      title: "Patient - Current Appointment - Staff Name",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_STAFF_NAME
    },
    {
      title: "Patient - Current Appointment - Type",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_TYPE
    },
    {
      title: "Patient - Current Appointment - Clinic",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_CLINIC
    },
    {
      title: "Patient - Current Appointment - Status",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_STATUS
    },
    {
      title: "Patient - Current Appointment - Outcome Notes",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_OUTCOME_NOTES
    },
    {
      title: "Patient - Current Appointment - Room",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_ROOM
    },
    {
      title: "Patient - Current Appointment - Physician Referral",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_PHYSICIAN_REFERRAL
    },
    {
      title: "Patient - Current Appointment - Companion Type",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_COMPANION_TYPE
    },
    {
      title: "Patient - Current Appointment - Companion Name",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_COMPANION_NAME
    },
    {
      title: "Patient - Current Appointment - Notes",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_NOTES
    },
    {
      title: "Patient - Current Appointment - Chart Notes",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_CHART_NOTES
    },
    {
      title: "Patient - Current Appointment - Provider Signature",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_STAFF_SIGNATURE
    },
    {
      title: "Patient - Current Appointment - Time",
      value: PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_TIME
    },
    {
      title: "Patient - Current Appointment - Provider License Number",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_PROVIDER_LICENSE_NUMBER
    },
    {
      title: "Patient - Current Appointment - Referral Source",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_REFERRAL_SOURCE
    },
    {
      title:
        "Patient - Current Appointment - Direct Supervising Provider Full Name",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_DIRECT_SUPERVISING_PROVIDER_FULL_NAME
    },
    {
      title:
        "Patient - Current Appointment - Direct Supervising Provider Signature",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_DIRECT_SUPERVISING_PROVIDER_SIGNATURE
    },
    {
      title: "Patient - Current Appointment - Supervising Provider Full Name",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_SUPERVISING_PROVIDER_FULL_NAME
    },
    {
      title: "Patient - Current Appointment - Supervising Provider Signature",
      value:
        PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_SUPERVISING_PROVIDER_SIGNATURE
    }
  ]
};

export const PATIENT_APPOINTMENTS_MENU_OPTIONS = {
  title: "Patient - Appointments",
  menu: [
    {
      title: "Next Appointment",
      menu: [
        {
          title: "Patient - Next Appointment - Date",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_DATE
        },
        {
          title: "Patient - Next Appointment - Date Time",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_DATE_TIME
        },
        {
          title: "Patient - Next Appointment - Staff Name",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_STAFF_NAME
        },
        {
          title: "Patient - Next Appointment - Type",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_TYPE
        },
        {
          title: "Patient - Next Appointment - Clinic",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_CLINIC
        },
        {
          title: "Patient - Next Appointment - Status",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_STATUS
        },
        {
          title: "Patient - Next Appointment - Outcome Notes",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_OUTCOME_NOTES
        },
        {
          title: "Patient - Next Appointment - Room",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_ROOM
        },
        {
          title: "Patient - Next Appointment - Physician Referral",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_PHYSICIAN_REFERRAL
        },
        {
          title: "Patient - Next Appointment - Companion Type",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_COMPANION_TYPE
        },
        {
          title: "Patient - Next Appointment - Companion Name",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_COMPANION_NAME
        },
        {
          title: "Patient - Next Appointment - Notes",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_NOTES
        },
        {
          title: "Patient - Next Appointment - Chart Notes",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_CHART_NOTES
        },
        {
          title: "Patient - Next Appointment - Provider Signature",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_STAFF_SIGNATURE
        },
        {
          title: "Patient - Next Appointment - Staff Email",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_STAFF_EMAIL
        },
        {
          title: "Patient - Next Appointment - Telehealth Link",
          value: PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_TELEHEALTH_LINK
        }
      ]
    },
    {
      title: "Last Appointment",
      menu: [
        {
          title: "Patient - Last Appointment - Date",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_DATE
        },
        {
          title: "Patient - Last Appointment - Date Time",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_DATE_TIME
        },
        {
          title: "Patient - Last Appointment - StaffName",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_STAFF_NAME
        },
        {
          title: "Patient - Last Appointment - Type",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_TYPE
        },
        {
          title: "Patient - Last Appointment - Clinic",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_CLINIC
        },
        {
          title: "Patient - Last Appointment - Status",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_STATUS
        },
        {
          title: "Patient - Last Appointment - Outcome Notes",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_OUTCOME_NOTES
        },
        {
          title: "Patient - Last Appointment - Room",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_ROOM
        },
        {
          title: "Patient - Last Appointment - Physician Referral",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_PHYSICIAN_REFERRAL
        },
        {
          title: "Patient - Last Appointment - Companion Type",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_COMPANION_TYPE
        },
        {
          title: "Patient - Last Appointment - Companion Name",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_COMPANION_NAME
        },
        {
          title: "Patient - Last Appointment - Notes",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_NOTES
        },
        {
          title: "Patient - Last Appointment - Chart Notes",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_CHART_NOTES
        },
        {
          title: "Patient - Last Appointment - Provider Signature",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_STAFF_SIGNATURE
        }
      ]
    },
    {
      title: "Chart Notes",
      menu: [
        {
          title: "Patient - My Last Chart Note",
          value: PATIENT_APPOINTMENTS_OPTIONS.MY_LAST_CHART_NOTE
        }
      ]
    },
    {
      title: "Last Appointment Invoice",
      menu: [
        {
          title: "Patient - Last Appointment Invoice - Status",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_STATUS
        },
        {
          title: "Patient - Last Appointment Invoice - Total",
          value: PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_TOTAL
        },
        {
          title:
            "Patient - Last Appointment Invoice - Patient - Responsibility",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_RESPONSIBILITY
        },
        {
          title:
            "Patient - Last Appointment Invoice - Patient - Responsibility Paid",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_RESPONSIBILITY_PAID
        },
        {
          title: "Patient - Last Appointment Invoice - Line Items Count",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_LINE_ITEMS_COUNT
        },
        {
          title: "Patient - Last Appointment Invoice - Line Items",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_LINE_ITEMS
        },
        {
          title: "Patient - Last Appointment Invoice - Payments Total",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_PAYMENTS_TOTAL
        },
        {
          title: "Patient - Last Appointment Invoice - Payments",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_PAYMENTS
        },
        {
          title: "Patient - Last Appointment Invoice - AdjustmentsTotal",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_ADJUSTMENTS_TOTAL
        },
        {
          title: "Patient - Last Appointment Invoice - Adjustments",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_ADJUSTMENTS
        },
        {
          title: "Patient - Last Appointment Invoice - Refunds Total",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_REFUNDS_TOTAL
        },
        {
          title: "Patient - Last Appointment Invoice - Refunds",
          value:
            PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_SALE_PATIENT_REFUNDS
        }
      ]
    }
  ]
};
